<template>
  <div
    :class="[
      'section-statistics__tab', 'section-statistics__row',
      {'section-statistics__row--long-table-mode': longTablePart}
    ]"
  >
    <BarPart />
    <TablePart />

    <template v-if="!longTablePart">
      <!-- <ErrorsCard v-if="!longTablePart" /> -->
      <DomainsCard v-if="commType === 'email'" />
    </template>
  </div>
</template>

<script>
import tabs_mixin from "@/components/statistics/stats/tabs/tabs_mixin";

// parts
import TablePart from "./TablePart.vue";
import BarPart from "./BarPart.vue";
// import ErrorsCard from '@/components/statistics/stats/tabs/delivery/Errors.vue';
import DomainsCard from '@/components/statistics/stats/tabs/delivery/Domains.vue';

export default {
  components: {
    TablePart,
    BarPart,
    // ErrorsCard,
    DomainsCard,
  },

  mixins: [tabs_mixin],
};
</script>